import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_27: DocMigration = {
  maxSchemaVersion: "0.0.27",
  apply(json: any) {
    const electricalElevationTablesToDelete: string[] = [];

    if (json.elevations) {
      for (const elevationId in json.elevations) {
        const value = json.elevations[elevationId];
        const settingsOverride = value?.settingsOverride;
        if (settingsOverride && settingsOverride["electrical"]) {
          const tableId = settingsOverride["electrical"];
          electricalElevationTablesToDelete.push(tableId);
          delete settingsOverride.electrical;
        }
      }
    }

    for (const tableId of electricalElevationTablesToDelete) {
      if (json?.tables?.settings[tableId]) {
        const settings = json.tables.settings;
        delete settings[tableId];
      }
    }

    return json;
  },
};

export default migration_0_0_27;
